import styled from 'styled-components';

// CONSTANTS
import { WHITE, ATHENS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  .swimlane,
  &.swimlane {
    &--highlighted,
    &--highlighted::after,
    &--highlighted::before {
      background-color: ${WHITE};
    }

    &--highlighted {
      position: relative;
      padding: 48px 0 30px;

      &::after,
      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
      }

      &::before {
        right: 100%;
      }

      &::after {
        left: 100%;
      }

      .banner-app {
        margin-bottom: 38px;
      }

      .carousel-wtw {
        position: relative;
        z-index: 1;
      }
    }

    &--app-features {
      h3 {
        ${breakpoints.down('xs')} {
          text-align: center;
        }
      }
    }

    &--multiple-content,
    &--multiple-content::after,
    &--multiple-content::before {
      background-color: ${ATHENS_GRAY};
    }

    &--multiple-content {
      padding-top: 40px !important;
      padding-bottom: 40px !important;

      .swimlane__title {
        margin-bottom: 50px;
      }

      .carousel-wtw:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }

    &__title {
      margin-bottom: 24px;
    }
  }
`;

export default Wrapper;
